


















































































import Vue from 'vue'
import Component from 'vue-class-component'
import {Prop, Watch} from 'vue-property-decorator';
import User from '@/modules/user/model/User';
import {FindUserCriteria} from '@/modules/user/api';
import UserList from '@/modules/user/components/UserList.vue';
import {State} from 'vuex-class';
import UserGroup from '@/modules/user/model/UserGroup';
import {notify} from '@/modules/core/notification';

@Component({
    components: {
        UserList,
    },
})
export default class AddGroupUsers extends Vue {
    public $refs: Vue['$refs'] & {
        users: {
            reload (): Promise<void>,
        },
    }

    /**
     * Controla la visibilidad del componente
     *
     * @var { boolean }
     */
    @Prop({type: Boolean, default: false})
    public value: boolean

    /**
     * Grupo de usuarios actualmente seleccionado
     *
     * @var { UserGroup }
     */
    @State(state => state.user.userGroup)
    public group: UserGroup

    /**
     * Usuarios seleccionados para añadir o eliminar al grupo
     *
     * @var { User[] }
     */
    @State(state => state.user.selectedGroupUsers)
    public selectedUsers: User[]

    public confirm = false
    public saving = false

    public userListFilters: FindUserCriteria = {}

    @Watch('group', {immediate: true})
    public watchGroup (group: UserGroup) {
        this.userListFilters.excludeGroups = [group.id]
    }

    public async addUsers () {
        if (this.group.isNew) {
            this.$store.commit('user/UPDATE_USER_GROUP_FIELD', {
                field: 'newUsers',
                value: this.selectedUsers,
            })

            this.$store.commit('user/SET_SELECTED_GROUP_USERS', [])
            this.confirm = false
            this.$emit('input', false)

            return
        }

        this.saving = true
        await this.$store.dispatch('user/addUsersToGroup')

        this.$emit('input', false)
        this.$emit('addedUsers', this.selectedUsers)
        this.saving = false
        this.confirm = false
        notify('Los usuarios se han añadido correctamente')

        this.$store.commit('user/SET_SELECTED_GROUP_USERS', [])
        await this.$refs.users.reload()
    }
}
